import classNames from 'classnames';
import styles from './Spinner.module.scss';
import { Container } from 'ui/components/4-habitats/Container/Container';

export interface SpinnerProps {
	style?: 'large' | 'slow' | 'error';
	loadingLabel?: string;
}

export const Spinner: React.FC<SpinnerProps> = ({ style, loadingLabel }) => (
	<Container width="Standard">
		<div className={classNames(styles.Spinner_screenReader, styles.Spinner_loadingMsg)} role="alert">
			{loadingLabel}
		</div>
		<div className={classNames(styles.Spinner, styles[`Spinner___${style}`])} aria-hidden="true"></div>
	</Container>
);
